<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card class="pa-5" elevation="0" color="#FAFAFA">

      <v-row class="mb-3">
        <v-col>
          <h3>템플릿 정보</h3>
        </v-col>
      </v-row>

        <v-row class="mb-4">
          <v-col>
            <h5 class="mb-2" style="color:black;">템플릿 이름</h5>
            <v-form ref="form" v-model="valid">
              <input v-model="name" label="템플릿 이름" placeholder="템플릿 이름" class="search-input" ref="nameInput">
            </v-form>
          </v-col>

          <v-col class="ml-3">
            <h5 class="mb-2" style="color:black;">타이틀</h5>
            <v-form ref="form" v-model="valid">
              <input v-model="title" label="타이틀" placeholder="타이틀" class="search-input" ref="ipInput">
            </v-form>
          </v-col>

        </v-row>

        <h3 class="mb-3">템플릿 타입</h3>

        <v-row>
          <v-col cols="12" sm="12" class="pa-0 pr-1">
            <v-card class="template_card" elevation="0" :class="{ active: activeMenu === 'Standard' }"
              @click="handleMenuClick('Standard')">
              <div style="display: flex;">
                <v-img src="@/styles/assets/templeate.png" width="180px" class="template_img" />
              <div class="template_txt pa-3">
                <h4 class="mb-2">Youtube 타입</h4>
                <span>유뷰브 타입의 형식으로 그룹화 시켜 영상을 정리할 수 있습니다.</span>
              </div>
              </div>
              
            </v-card>
          </v-col>
          <!-- <v-col cols="12" sm="6" class="pa-0 pl-1">
            <v-card class="template_card" elevation="0" :class="{ active: activeMenu === 'Playlist' }"
              @click="handleMenuClick('Playlist')">
              <v-img src="@/styles/assets/templeate.png" class="img_box" />
              <div class="template_txt pa-3">
                <h4 class="mb-2">Playlist 타입</h4>
                <span>유뷰브 타입의 형식으로 그룹화 시켜 영상을 정리할 수 있습니다.</span>
              </div>
            </v-card>
          </v-col> -->
        </v-row>

        <div class="mt-4">
          <TextButtonBlock :buttonText="$store.getters.t('닫기')" :width="'49%'" class="mr-2" @click="closeModal" />
          <TextButtonBlock :buttonText="$store.getters.t('생성')" :width="'49%'" isPrimary @click="createTemplate" />
        </div>
          
        
        

    </v-card>
  </v-dialog>
</template>

<script>
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import TemplateApi from "@/api/template/TemplateApi";

export default {
  components: {
    TextButtonBlock,
  },
  props: ['value'],
  data() {
    return {
      dialog: this.value,
      activeMenu: null,
      valid: '',
      name: null,
      title: null,
      type: null,
    };
  },
  methods: {
    closeModal() {
      this.dialog = false;
      this.name = null;
      this.title = null;
      this.activeMenu = null;
      this.$emit('input', this.dialog);
    },
    async createTemplate() {
      try {
        const data = {
          template_name: this.name,
          title: this.title,
          type: this.activeMenu
        }
        //console.log('data', data);
        const response = await TemplateApi.addApi(data);
        if (response.status === 201) {
          this.closeModal();
          this.$emit('update');
        }
      } catch (error) {
        console.error('Error:', error.message);
      }
    },
    handleMenuClick(menu) {
      this.activeMenu = menu;
    },
  },
  watch: {
    value(newValue) {
      this.dialog = newValue;
    },
    dialog(newValue) {
      this.$emit('input', newValue);
    },

  },
}
</script>

<style lang="scss" scoped>
.template_card {
  border: 1px solid #ddd;
  border-radius: 10px;
  cursor: pointer;
}
.template_img{
  border-radius: 10px 0 0 10px;
}
.template_card.active {
  border: 2px solid #006cea;
}
.template_txt {
  border-left: 1px solid #ddd;
}
.template_txt span {
  font-size: 14px;
}
</style>